export const SUPPORT_URL = 'https://support.envirosuite.com';
